// extracted by mini-css-extract-plugin
module.exports = {"wrap":"InlineColor-styles-module--wrap--33UfV","swatch":"InlineColor-styles-module--swatch--1ktiS"};